import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import type { footerProps } from './types.props';


const Footer: React.FC<footerProps> = ({
    emailToCopy = 'extension.ingenierias@utp.edu.co',
    websiteUrl = 'www.edudata.com.co'
}) => {

    const copyEmail = () => {
        navigator.clipboard.writeText(emailToCopy).then(() => {
            alert(`Email "${emailToCopy}" copiado al portapapeles.`);
        }).catch(err => {
            console.error('Error al copiar el email: ', err);
            alert('No se pudo copiar el email.');
        });
    };

    return (
        <footer className={styles['app-footer']}>
            <p>{websiteUrl}</p>
            <p
                className={styles['app-footer-email']}
                onClick={copyEmail}
                title={`Haz clic para copiar ${emailToCopy}`}
            >
                {emailToCopy}
            </p>
            <div className={styles['app-footer-links']}>
                <Link to="/politica-de-tratamiento" className={styles['app-footer-link']}>
                    Política de Tratamiento de Datos
                </Link>
                <Link to="/aviso-de-privacidad" className={styles['app-footer-link']}>
                    Aviso de Privacidad
                </Link>
            </div>
        </footer>
    );
};

export default Footer;
